import ezPayPlusLogo from "assets/ez_pay_plus_logo.svg";
import kubraLogo from "assets/kubra_logo.svg";
import { KUBRA_PRIVACY_POLICY_URL, KUBRA_TERMS_OF_USE_URL } from "constants/externalUrls";
import { MENU_NAMESPACE } from "constants/i18n-namespaces";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Outlet, useOutletContext } from "react-router";
import { useLocation } from "react-router-dom";
import { getPayableSession } from "selectors/payableSession";
import { ISession } from "types/session";
import {
  LinkBorder,
  StyledFooter,
  StyledUlLinks,
} from "./styled-components/styled-footer";

export const PayableFooter = (props: { isMobile: boolean }) => {
  const session = useOutletContext<ISession>();
  const payableSession = useSelector(getPayableSession);
  const { t } = useTranslation();
  const location = useLocation();

  const aboutKubraEzPayUrl = "https://www.kubra.com/products-and-services/billing-and-payments/kubra-ez-pay";

  useEffect(() => {
    if (location.pathname.includes("terms")) {
      window.open(KUBRA_TERMS_OF_USE_URL, "_blank", 'noopener');
    } else if (location.pathname.includes("privacy")) {
      window.open(KUBRA_PRIVACY_POLICY_URL, "_blank", 'noopener')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledFooter data-cy="ez-pay-footer">
        <div className="ez-pay-menu-main">
          <span className="ez-pay-menu-logo-helper"></span>
          <img
            src={ezPayPlusLogo}
            alt="KUBRA EZ-PAY+"
            className="ez-pay-menu-logo"
            data-cy="menu-logo"
          />
        </div>
        <StyledUlLinks data-cy="links">
          <span className="footer-copyright-text" data-cy="footer-copyright-text">
            {t("copy-right-kubra-cx", { ns: MENU_NAMESPACE, year: new Date().getFullYear() })}
          </span>
          <LinkBorder />
          <span className="footer-all-rights-reserved-text" data-cy="footer-all-rights-reserved-text">
            {t("all-rights-reserved", { ns: MENU_NAMESPACE })}
          </span>
          {
            !props.isMobile && <LinkBorder />
          }
          <a
            data-cy="navigate-about"
            href={aboutKubraEzPayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="payable-footer-link-button payable-footer-about-link"
          >
            {t("about-ez-pay", { ns: MENU_NAMESPACE })}+
          </a>
          {
            !props.isMobile && <LinkBorder />
          }
          <a
            data-cy="navigate-policy"
            href={KUBRA_PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="payable-footer-link-button"
          >
            {t("privacy-policy", { ns: MENU_NAMESPACE })}
          </a>
          <LinkBorder />
          <a
            data-cy="navigate-terms"
            href={KUBRA_TERMS_OF_USE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="payable-footer-link-button"
          >
            {t("terms-of-use", { ns: MENU_NAMESPACE })}
          </a>
          {
            !props.isMobile && <LinkBorder />
          }
          <img
            src={kubraLogo}
            alt="KUBRA"
            className="kubra-menu-logo-footer"
            data-cy="menu-logo-kubra-footer"
          />
        </StyledUlLinks>
      </StyledFooter>
      <Outlet context={session || payableSession} />
    </>
  );
};